

export interface status {
  id: number;
  name: string;
  code: string;
  color: string;
}

interface StatusDropdownProps {
  options: status[];
  value: number;
  onChange: (id: number) => void;
}

export default function StatusDropdown({
  options,
  value,
  onChange,
}: StatusDropdownProps) {
  const selectedValue = options.some((item) => item.id === value) ? value : 0;

  return (
    <select
      value={selectedValue}
      onChange={(e) => onChange(Number(e.target.value))}
      className="rounded-lg border border-gray-200 px-3 py-2 text-sm">
      <option value={0} disabled>
        Select Status
      </option>

      {options.map((status) => (
        <option key={status.id} value={status.id}>
          {status.name}
        </option>
      ))}
    </select>
  );
}

